'use client';
import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon/index.js';
import { TableHeaderCellStyled, TableHeaderCellButtonStyled } from './Table.styles.js';
import { TEXT_ALIGN, TABLE_SIZES, SORT_ICONS } from './Table.constants.js';

var _excluded = ["children", "sortCb", "sortState", "textAlign", "size"];
var TableHeaderCell = function TableHeaderCell(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$sortCb = _ref.sortCb,
    sortCb = _ref$sortCb === void 0 ? null : _ref$sortCb,
    _ref$sortState = _ref.sortState,
    sortState = _ref$sortState === void 0 ? '' : _ref$sortState,
    _ref$textAlign = _ref.textAlign,
    textAlign = _ref$textAlign === void 0 ? TEXT_ALIGN.LEFT : _ref$textAlign,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? TABLE_SIZES.SMALL : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  if (sortCb) {
    return React__default.createElement(TableHeaderCellStyled, _extends({}, props, {
      $textAlign: textAlign,
      $isSortable: sortCb,
      $size: size
    }), React__default.createElement(TableHeaderCellButtonStyled, {
      $textAlign: textAlign,
      type: "button",
      onClick: sortCb
    }, children, sortState && React__default.createElement(Icon, {
      variant: SORT_ICONS[sortState],
      size: "small"
    })));
  }
  return React__default.createElement(TableHeaderCellStyled, _extends({}, props, {
    $textAlign: textAlign,
    $isSortable: sortCb,
    $size: size
  }), children);
};
TableHeaderCell.propTypes = {
  children: PropTypes.node,
  size: PropTypes.oneOf(Object.values(TABLE_SIZES)),
  sortCb: PropTypes.func,
  sortState: PropTypes.string,
  textAlign: PropTypes.oneOf(Object.values(TEXT_ALIGN))
};
var TableHeaderCell$1 = TableHeaderCell;

export { TableHeaderCell$1 as default };
//# sourceMappingURL=TableHeaderCell.js.map
